

import profile from '../../../common/mixins/profile'
import alertWeb from '../../../common/mixins/alertWeb'
import redirectWeb from '../../../common/mixins/redirectWeb'

export default {
  name: 'PasswordChange',
  mixins: [profile, alertWeb, redirectWeb]
}
